export default {"src":"/_next/static/media/illustration-ship.707e41f2.svg","height":152,"width":152};